export enum StatusCode {
    ALREADY_EXIST_409 = 409,
    PERMISSION_401    = 401,
    PERMISSION_403    = 403,
    SERVER_500        = 500,
    SERVER_502        = 502,
    SERVER_504        = 504
}
